import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";

const FormActions = ({
  onCancel,
  onSave,
  cancelText = "Cancel",
  saveText,
  isUpdate,
  cancelColor = "error",
  saveColor = "primary",
  cancelVariant = "contained",
  saveVariant = "contained",
  sx = { display: "flex", justifyContent: "end", gap: 1 },
  loading
}) => {
  return (
    <Box sx={sx}>
      <Button variant={cancelVariant} color={cancelColor} onClick={onCancel} size="small">
        {cancelText}
      </Button>
      <Button
        variant={saveVariant}
        color={saveColor}
        onClick={onSave}
        disabled={loading}
        size="small"
        startIcon={
          loading ? <CircularProgress size={20} color="inherit" /> : null
        }
      >
        {isUpdate ? "Update" : saveText}
      </Button>
    </Box>
  );
};

export default FormActions;
